import React from 'react';
import PropTypes from 'prop-types';
import { Box, Spacer } from '@eatclubapp/ec-component-library';
import { useTheme } from '@mui/material/styles';
import { COLORS, FONT_WEIGHTS } from '../../ObeeTheme';

const ColumnSection = ({ children, label }) => {
  const theme = useTheme();
  // const isBreakpointDownSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isBreakpointDownSm = false; // TODO fix this

  return (
    <Box
      style={{
        alignItems: 'baseline',
        display: 'grid',
        gap: '32px',
        gridTemplateColumns: !isBreakpointDownSm && '160px auto',
      }}
    >
      <Box style={{ fontSize: '18px', fontWeight: FONT_WEIGHTS.MEDIUM, color: COLORS.BLACK }}>
        {label}
      </Box>

      <Spacer direction='vertical' gap='l' style={{ maxWidth: '480px' }}>
        {children}
      </Spacer>
    </Box>
  );
};

ColumnSection.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

export default ColumnSection;
